import { PrometheusQuery } from "./PrometheusQuery";

export class JetsonFanSpeed extends PrometheusQuery {
  protected _id: string = "jetson_fan_speed";

  public override getPossibleValues() {
    return [
      { id: "Jetson - Fan speed", color: "#0048e3" }
    ]
  };
  
  public override getRefinedData() {
    const refinedData = [];

    if (this.isEmpty()) return [];
    
    for (let i = 0; i < this._queryData.data.result[0].values.length; i += 1) {
      refinedData.push({
        date: this.formatDate(this._queryData.data.result[0].values[i][0]),
        "Jetson - Fan speed": this._queryData.data.result[0].values[i][1]
      })
    }

    return refinedData;
  }

  public override getDomain() {
    if (this.isEmpty()) return [0, 100]
    return undefined;
  }

  public override getMiddleValue() {
    return 50;
  }

  public override getValueLabel() {
    return "%";
  }
}